module.exports = __webpack_public_path__ + "static/img/03.1ca7af99.png";